import { model as router } from '!/router'
import { InlineBackAngleWithTitle } from '@setplex/arcana'
import { useUnit } from 'effector-react'
import { type SyntheticEvent } from 'react'
import { translations } from '../model'

export const BackButton = () => {
  const formTranslations = useUnit(translations.$verifyFormTranslation)
  const onGoBack = (e: SyntheticEvent) => {
    e.preventDefault()
    e.stopPropagation()
    router.navigateBack()
  }
  return (
    <InlineBackAngleWithTitle
      title={formTranslations.back}
      onClick={onGoBack}
    />
  )
}
